export function toFarsiNumber(n) {
  const farsiDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

  return n
    .toString()
    .split("")
    .map((x) => {
      return isNaN(Number(x)) ? x : farsiDigits[Number(x)];
    })
    .join("");
}